import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-canal-performance',
  templateUrl: './canal-performance.component.html',
  styleUrls: ['./canal-performance.component.css']
})
export class CanalPerformanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
